// extracted by mini-css-extract-plugin
module.exports = {"textSkeleton":"AuctionPreview_textSkeleton__2XRnU","imageSkeleton":"AuctionPreview_imageSkeleton__1Futm"};